import React, { useState, useEffect } from 'react';
import { useScopedBaseConfig } from './src-contexts-CouponCalloutConfig.context.js';
import { LocalizationsProvider } from './src-hooks-useLocalizations.js';
import { setVersionOnWindow } from './src-hooks-useSetVersionOnWindow.js';
import { useCouponDetailsStore } from './src-store-couponDetails.store.js';
import { getQueryKey } from './src-utils-generic.util.js';
import { CouponCalloutDisplay } from './src-components-CouponDisplay-CouponCalloutDisplay.js';

const CouponCalloutExtractionWrapper = (props) => {
  const { mpvId, productId, version, quantity, selections, asLowAsPrice } = props;
  const addQuery = useCouponDetailsStore((state) => state.addQuery);
  const baseConfig = useScopedBaseConfig();
  const isPricingContextInitialized = useCouponDetailsStore((state) => state.pricingContext?.isInitialized);
  const localizations = useCouponDetailsStore((state) => state.localizations);
  const { pageId } = baseConfig;
  const [lastValidCouponQueryKey, setLastValidCouponQueryKey] = useState("");
  setVersionOnWindow();
  useEffect(() => {
    if (isPricingContextInitialized) {
      if (!mpvId && !productId) {
        throw new Error("Missing mpvId or productId in query");
      } else if (productId && !version) {
        throw new Error("Missing version in query");
      } else if (mpvId) {
        addQuery({ mpvId, quantity, selections }, baseConfig);
      } else {
        addQuery({ productId, version, quantity, selections }, baseConfig);
      }
    }
  }, [mpvId, productId, version, quantity, selections, isPricingContextInitialized, addQuery]);
  let queryKey = "";
  if (mpvId) {
    queryKey = getQueryKey({ mpvId, quantity, selections }) || "";
  } else if (productId && version) {
    queryKey = getQueryKey({ productId, version, quantity, selections }) || "";
  }
  const productCouponData = useCouponDetailsStore(
    (state) => state.data[pageId]?.couponDetails?.productCouponData
  );
  const liveProductCouponDetails = productCouponData?.[queryKey];
  const lastValidProductCouponDetails = lastValidCouponQueryKey ? productCouponData?.[lastValidCouponQueryKey] : void 0;
  useEffect(() => {
    if (liveProductCouponDetails) {
      setLastValidCouponQueryKey(queryKey);
    }
  }, [liveProductCouponDetails, queryKey]);
  const couponDetailsToUse = liveProductCouponDetails ?? lastValidProductCouponDetails;
  if (!isPricingContextInitialized || !baseConfig || !couponDetailsToUse) {
    return null;
  }
  const effectiveQueryKey = liveProductCouponDetails ? queryKey : lastValidCouponQueryKey;
  return /* @__PURE__ */ React.createElement(LocalizationsProvider, { localizations }, /* @__PURE__ */ React.createElement(
    CouponCalloutDisplay,
    {
      queryKey: effectiveQueryKey,
      asLowAsPrice
    }
  ));
};

export { CouponCalloutExtractionWrapper };
//# sourceMappingURL=src-components-CouponCalloutExtraction-CouponCalloutExtractionWrapper.js.map
